import Styles from './ActivityEvent.module.scss'
import { ReactComponent as ArrowDown } from 'assets/icons/arrowDown16.svg'

interface Props {
  entry: IntersectionObserverEntry | undefined
}

const ArticleLastViewedLocator = ({ entry }: Props) => {
  if (!entry || entry.isIntersecting || !entry.rootBounds) {
    return null
  }

  const position = entry.boundingClientRect.y < entry.rootBounds.y ? 'above' : 'below'

  const handleClick = () => {
    entry.target.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  return (
    <div className={Styles.lastViewedToastWrapper} style={{ display: position === 'above' ? 'none' : 'flex' }}>
      <div className={Styles.lastViewedToast} onClick={handleClick}>
        <ArrowDown /> Last time you were here
      </div>
    </div>
  )
}

export { ArticleLastViewedLocator }
